import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["render", "orientation", "loop", "cols", "disabledIndices", "activeIndex", "onNavigate", "itemSizes", "dense"],
  _excluded2 = ["render"],
  _excluded3 = ["transform"],
  _excluded4 = ["context", "width", "height", "tipRadius", "strokeWidth", "staticOffset", "stroke", "d", "style"],
  _excluded5 = ["lockScroll"],
  _excluded6 = ["listRef", "overflowRef", "onFallbackChange", "offset", "index", "minItemsVisible", "referenceOverflowThreshold", "scrollRef"];
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useLayoutEffect, useEffect, useRef } from 'react';
import { stopEvent, getDocument, isMouseLikePointerType, contains, activeElement, isSafari, isTypeableCombobox, isVirtualClick, isVirtualPointerEvent, getTarget, getPlatform, isTypeableElement, isReactEvent, isRootElement, isEventTargetWithin, isMac, getUserAgent } from '@floating-ui/react/utils';
import { floor, evaluate } from '@floating-ui/utils';
import { getComputedStyle, isElement, getNodeName, isHTMLElement, getWindow, isLastTraversableNode, getParentNode } from '@floating-ui/utils/dom';
import { tabbable, isTabbable } from 'tabbable';
import * as ReactDOM from 'react-dom';
import { getOverflowAncestors, useFloating as useFloating$1, offset, detectOverflow } from '@floating-ui/react-dom';
export { arrow, autoPlacement, autoUpdate, computePosition, detectOverflow, flip, getOverflowAncestors, hide, inline, limitShift, offset, platform, shift, size } from '@floating-ui/react-dom';

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */
function useMergeRefs(refs) {
  return React.useMemo(function () {
    if (refs.every(function (ref) {
      return ref == null;
    })) {
      return null;
    }
    return function (value) {
      refs.forEach(function (ref) {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var SafeReact = _objectSpread({}, React);
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || function (fn) {
  return fn();
};
function useEffectEvent(callback) {
  var ref = React.useRef(function () {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(function () {
    ref.current = callback;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current.apply(ref, args);
  }, []);
}
var ARROW_UP = 'ArrowUp';
var ARROW_DOWN = 'ArrowDown';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_RIGHT = 'ArrowRight';
function isDifferentRow(index, cols, prevRow) {
  return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
  return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices: disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices: disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  var _ref5 = _temp === void 0 ? {} : _temp,
    _ref5$startingIndex = _ref5.startingIndex,
    startingIndex = _ref5$startingIndex === void 0 ? -1 : _ref5$startingIndex,
    _ref5$decrement = _ref5.decrement,
    decrement = _ref5$decrement === void 0 ? false : _ref5$decrement,
    disabledIndices = _ref5.disabledIndices,
    _ref5$amount = _ref5.amount,
    amount = _ref5$amount === void 0 ? 1 : _ref5$amount;
  var list = listRef.current;
  var index = startingIndex;
  do {
    index += decrement ? -amount : amount;
  } while (index >= 0 && index <= list.length - 1 && isDisabled(list, index, disabledIndices));
  return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  var event = _ref.event,
    orientation = _ref.orientation,
    loop = _ref.loop,
    cols = _ref.cols,
    disabledIndices = _ref.disabledIndices,
    minIndex = _ref.minIndex,
    maxIndex = _ref.maxIndex,
    prevIndex = _ref.prevIndex,
    _ref$stopEvent = _ref.stopEvent,
    stop = _ref$stopEvent === void 0 ? false : _ref$stopEvent;
  var nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices: disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        var col = prevIndex % cols;
        var maxCol = maxIndex % cols;
        var _offset = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? _offset : _offset - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices: disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices: disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }

  // Remains on the same row/column.
  if (orientation === 'both') {
    var prevRow = floor(prevIndex / cols);
    if (event.key === ARROW_RIGHT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices: disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices: disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices: disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === ARROW_LEFT) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices: disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices: disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices: disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    var lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === ARROW_LEFT ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices: disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}

/** For each cell index, gets the item index that occupies that cell */
function buildCellMap(sizes, cols, dense) {
  var cellMap = [];
  var startIndex = 0;
  sizes.forEach(function (_ref2, index) {
    var width = _ref2.width,
      height = _ref2.height;
    if (width > cols) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error("[Floating UI]: Invalid grid - item width at index " + index + " is greater than grid columns");
      }
    }
    var itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      var targetCells = [];
      for (var i = 0; i < width; i++) {
        for (var j = 0; j < height; j++) {
          targetCells.push(startIndex + i + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every(function (cell) {
        return cellMap[cell] == null;
      })) {
        targetCells.forEach(function (cell) {
          cellMap[cell] = index;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });

  // convert into a non-sparse array
  return [].concat(cellMap);
}

/** Gets cell index of an item's corner or -1 when index is -1. */
function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
  if (index === -1) return -1;
  var firstCellIndex = cellMap.indexOf(index);
  var sizeItem = sizes[index];
  switch (corner) {
    case 'tl':
      return firstCellIndex;
    case 'tr':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case 'bl':
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case 'br':
      return cellMap.lastIndexOf(index);
  }
}

/** Gets all cell indices that correspond to the specified indices */
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap(function (index, cellIndex) {
    return indices.includes(index) ? [cellIndex] : [];
  });
}
function isDisabled(list, index, disabledIndices) {
  if (disabledIndices) {
    return disabledIndices.includes(index);
  }
  var element = list[index];
  return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$preventScrol = _options.preventScroll,
    preventScroll = _options$preventScrol === void 0 ? false : _options$preventScrol,
    _options$cancelPrevio = _options.cancelPrevious,
    cancelPrevious = _options$cancelPrevio === void 0 ? true : _options$cancelPrevio,
    _options$sync = _options.sync,
    sync = _options$sync === void 0 ? false : _options$sync;
  cancelPrevious && cancelAnimationFrame(rafId);
  var exec = function exec() {
    return el == null ? void 0 : el.focus({
      preventScroll: preventScroll
    });
  };
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}
var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
function sortByDocumentPosition(a, b) {
  var position = a.compareDocumentPosition(b);
  if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
    return -1;
  }
  if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
    return 1;
  }
  return 0;
}
function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) {
    return false;
  }
  var _iterator = _createForOfIteratorHelper(map1.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      if (value !== map2.get(key)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
var FloatingListContext = /*#__PURE__*/React.createContext({
  register: function register() {},
  unregister: function unregister() {},
  map: /*#__PURE__*/new Map(),
  elementsRef: {
    current: []
  }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */
function FloatingList(props) {
  var children = props.children,
    elementsRef = props.elementsRef,
    labelsRef = props.labelsRef;
  var _React$useState = React.useState(function () {
      return new Map();
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    map = _React$useState2[0],
    setMap = _React$useState2[1];
  var register = React.useCallback(function (node) {
    setMap(function (prevMap) {
      return new Map(prevMap).set(node, null);
    });
  }, []);
  var unregister = React.useCallback(function (node) {
    setMap(function (prevMap) {
      var map = new Map(prevMap);
      map.delete(node);
      return map;
    });
  }, []);
  index(function () {
    var newMap = new Map(map);
    var nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
    nodes.forEach(function (node, index) {
      newMap.set(node, index);
    });
    if (!areMapsEqual(map, newMap)) {
      setMap(newMap);
    }
  }, [map]);
  return /*#__PURE__*/React.createElement(FloatingListContext.Provider, {
    value: React.useMemo(function () {
      return {
        register: register,
        unregister: unregister,
        map: map,
        elementsRef: elementsRef,
        labelsRef: labelsRef
      };
    }, [register, unregister, map, elementsRef, labelsRef])
  }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */
function useListItem(props) {
  if (props === void 0) {
    props = {};
  }
  var _props = props,
    label = _props.label;
  var _React$useContext2 = React.useContext(FloatingListContext),
    register = _React$useContext2.register,
    unregister = _React$useContext2.unregister,
    map = _React$useContext2.map,
    elementsRef = _React$useContext2.elementsRef,
    labelsRef = _React$useContext2.labelsRef;
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    index$1 = _React$useState4[0],
    setIndex = _React$useState4[1];
  var componentRef = React.useRef(null);
  var ref = React.useCallback(function (node) {
    componentRef.current = node;
    if (index$1 !== null) {
      elementsRef.current[index$1] = node;
      if (labelsRef) {
        var _node$textContent;
        var isLabelDefined = label !== undefined;
        labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
      }
    }
  }, [index$1, elementsRef, labelsRef, label]);
  index(function () {
    var node = componentRef.current;
    if (node) {
      register(node);
      return function () {
        unregister(node);
      };
    }
  }, [register, unregister]);
  index(function () {
    var index = componentRef.current ? map.get(componentRef.current) : null;
    if (index != null) {
      setIndex(index);
    }
  }, [map]);
  return React.useMemo(function () {
    return {
      ref: ref,
      index: index$1 == null ? -1 : index$1
    };
  }, [index$1, ref]);
}
function renderJsx(render, computedProps) {
  if (typeof render === 'function') {
    return render(computedProps);
  }
  if (render) {
    return /*#__PURE__*/React.cloneElement(render, computedProps);
  }
  return /*#__PURE__*/React.createElement("div", computedProps);
}
var CompositeContext = /*#__PURE__*/React.createContext({
  activeIndex: 0,
  onNavigate: function onNavigate() {}
});
var horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
var verticalKeys = [ARROW_UP, ARROW_DOWN];
var allKeys = [].concat(horizontalKeys, verticalKeys);

/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */
var Composite = /*#__PURE__*/React.forwardRef(function Composite(props, forwardedRef) {
  var render = props.render,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'both' : _props$orientation,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    _props$cols = props.cols,
    cols = _props$cols === void 0 ? 1 : _props$cols,
    disabledIndices = props.disabledIndices,
    externalActiveIndex = props.activeIndex,
    externalSetActiveIndex = props.onNavigate,
    itemSizes = props.itemSizes,
    _props$dense = props.dense,
    dense = _props$dense === void 0 ? false : _props$dense,
    domProps = _objectWithoutProperties(props, _excluded);
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    internalActiveIndex = _React$useState6[0],
    internalSetActiveIndex = _React$useState6[1];
  var activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
  var onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
  var elementsRef = React.useRef([]);
  var renderElementProps = render && typeof render !== 'function' ? render.props : {};
  var contextValue = React.useMemo(function () {
    return {
      activeIndex: activeIndex,
      onNavigate: onNavigate
    };
  }, [activeIndex, onNavigate]);
  var isGrid = cols > 1;
  function handleKeyDown(event) {
    if (!allKeys.includes(event.key)) return;
    var nextIndex = activeIndex;
    var minIndex = getMinIndex(elementsRef, disabledIndices);
    var maxIndex = getMaxIndex(elementsRef, disabledIndices);
    if (isGrid) {
      var sizes = itemSizes || Array.from({
        length: elementsRef.current.length
      }, function () {
        return {
          width: 1,
          height: 1
        };
      });
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      var cellMap = buildCellMap(sizes, cols, dense);
      var minGridIndex = cellMap.findIndex(function (index) {
        return index != null && !isDisabled(elementsRef.current, index, disabledIndices);
      });
      // last enabled index
      var maxGridIndex = cellMap.reduce(function (foundIndex, index, cellIndex) {
        return index != null && !isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex;
      }, -1);
      nextIndex = cellMap[getGridNavigatedIndex({
        current: cellMap.map(function (itemIndex) {
          return itemIndex ? elementsRef.current[itemIndex] : null;
        })
      }, {
        event: event,
        orientation: orientation,
        loop: loop,
        cols: cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([].concat(_toConsumableArray(disabledIndices || elementsRef.current.map(function (_, index) {
          return isDisabled(elementsRef.current, index) ? index : undefined;
        })), [undefined]), cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction we're
        // moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === ARROW_RIGHT ? 'tr' : 'tl')
      })]; // navigated cell will never be nullish
    }
    var toEndKeys = {
      horizontal: [ARROW_RIGHT],
      vertical: [ARROW_DOWN],
      both: [ARROW_RIGHT, ARROW_DOWN]
    }[orientation];
    var toStartKeys = {
      horizontal: [ARROW_LEFT],
      vertical: [ARROW_UP],
      both: [ARROW_LEFT, ARROW_UP]
    }[orientation];
    var preventedKeys = isGrid ? allKeys : {
      horizontal: horizontalKeys,
      vertical: verticalKeys,
      both: allKeys
    }[orientation];
    if (nextIndex === activeIndex && [].concat(_toConsumableArray(toEndKeys), _toConsumableArray(toStartKeys)).includes(event.key)) {
      if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) {
        nextIndex = minIndex;
      } else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) {
        nextIndex = maxIndex;
      } else {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: nextIndex,
          decrement: toStartKeys.includes(event.key),
          disabledIndices: disabledIndices
        });
      }
    }
    if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
      event.stopPropagation();
      if (preventedKeys.includes(event.key)) {
        event.preventDefault();
      }
      onNavigate(nextIndex);

      // Wait for FocusManager `returnFocus` to execute.
      queueMicrotask(function () {
        enqueueFocus(elementsRef.current[nextIndex]);
      });
    }
  }
  var computedProps = _objectSpread(_objectSpread(_objectSpread({}, domProps), renderElementProps), {}, {
    ref: forwardedRef,
    'aria-orientation': orientation === 'both' ? undefined : orientation,
    onKeyDown: function onKeyDown(e) {
      domProps.onKeyDown == null || domProps.onKeyDown(e);
      renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
      handleKeyDown(e);
    }
  });
  return /*#__PURE__*/React.createElement(CompositeContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(FloatingList, {
    elementsRef: elementsRef
  }, renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */
var CompositeItem = /*#__PURE__*/React.forwardRef(function CompositeItem(props, forwardedRef) {
  var render = props.render,
    domProps = _objectWithoutProperties(props, _excluded2);
  var renderElementProps = render && typeof render !== 'function' ? render.props : {};
  var _React$useContext3 = React.useContext(CompositeContext),
    activeIndex = _React$useContext3.activeIndex,
    onNavigate = _React$useContext3.onNavigate;
  var _useListItem = useListItem(),
    ref = _useListItem.ref,
    index = _useListItem.index;
  var mergedRef = useMergeRefs([ref, forwardedRef, renderElementProps.ref]);
  var isActive = activeIndex === index;
  var computedProps = _objectSpread(_objectSpread(_objectSpread({}, domProps), renderElementProps), {}, {
    ref: mergedRef,
    tabIndex: isActive ? 0 : -1,
    'data-active': isActive ? '' : undefined,
    onFocus: function onFocus(e) {
      domProps.onFocus == null || domProps.onFocus(e);
      renderElementProps.onFocus == null || renderElementProps.onFocus(e);
      onNavigate(index);
    }
  });
  return renderJsx(render, computedProps);
});
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var serverHandoffComplete = false;
var count = 0;
var genId = function genId() {
  return (
    // Ensure the id is unique with multiple independent versions of Floating UI
    // on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
  );
};
function useFloatingId() {
  var _React$useState7 = React.useState(function () {
      return serverHandoffComplete ? genId() : undefined;
    }),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    id = _React$useState8[0],
    setId = _React$useState8[1];
  index(function () {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    serverHandoffComplete = true;
  }, []);
  return id;
}
var useReactId = SafeReact.useId;

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */
var useId = useReactId || useFloatingId;
var devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /*#__PURE__*/new Set();
}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  var message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  var message = "Floating UI: " + messages.join(' ');
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}

/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */
var FloatingArrow = /*#__PURE__*/React.forwardRef(function FloatingArrow(props, ref) {
  var _props$context = props.context,
    placement = _props$context.placement,
    floating = _props$context.elements.floating,
    arrow = _props$context.middlewareData.arrow,
    _props$width = props.width,
    width = _props$width === void 0 ? 14 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 7 : _props$height,
    _props$tipRadius = props.tipRadius,
    tipRadius = _props$tipRadius === void 0 ? 0 : _props$tipRadius,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 0 : _props$strokeWidth,
    staticOffset = props.staticOffset,
    stroke = props.stroke,
    d = props.d,
    _props$style = props.style,
    _props$style2 = _props$style === void 0 ? {} : _props$style,
    transform = _props$style2.transform,
    restStyle = _objectWithoutProperties(_props$style2, _excluded3),
    rest = _objectWithoutProperties(props, _excluded4);
  if (process.env.NODE_ENV !== "production") {
    if (!ref) {
      warn('The `ref` prop is required for `FloatingArrow`.');
    }
  }
  var clipPathId = useId();
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isRTL = _React$useState10[0],
    setIsRTL = _React$useState10[1];

  // https://github.com/floating-ui/floating-ui/issues/2932
  index(function () {
    if (!floating) return;
    var isRTL = getComputedStyle(floating).direction === 'rtl';
    if (isRTL) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }

  // Strokes must be double the border width, this ensures the stroke's width
  // works as you'd expect.
  var computedStrokeWidth = strokeWidth * 2;
  var halfStrokeWidth = computedStrokeWidth / 2;
  var svgX = width / 2 * (tipRadius / -8 + 1);
  var svgY = height / 2 * tipRadius / 4;
  var _placement$split = placement.split('-'),
    _placement$split2 = _slicedToArray(_placement$split, 2),
    side = _placement$split2[0],
    alignment = _placement$split2[1];
  var isCustomShape = !!d;
  var isVerticalSide = side === 'top' || side === 'bottom';
  var yOffsetProp = staticOffset && alignment === 'end' ? 'bottom' : 'top';
  var xOffsetProp = staticOffset && alignment === 'end' ? 'right' : 'left';
  if (staticOffset && isRTL) {
    xOffsetProp = alignment === 'end' ? 'left' : 'right';
  }
  var arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : '';
  var arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : '';
  var dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
  var rotation = {
    top: isCustomShape ? 'rotate(180deg)' : '',
    left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
    bottom: isCustomShape ? '' : 'rotate(180deg)',
    right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
  }[side];
  return /*#__PURE__*/React.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref: ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      position: 'absolute',
      pointerEvents: 'none'
    }, xOffsetProp, arrowX), yOffsetProp, arrowY), side, isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)"), "transform", "" + rotation + (transform != null ? transform : '')), restStyle)
  }), computedStrokeWidth > 0 && /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke: stroke
    // Account for the stroke on the fill path rendered below.
    ,

    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /*#__PURE__*/React.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : 'none',
    d: dValue
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
});
function createPubSub() {
  var map = new Map();
  return {
    emit: function emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach(function (handler) {
        return handler(data);
      });
    },
    on: function on(event, listener) {
      map.set(event, [].concat(_toConsumableArray(map.get(event) || []), [listener]));
    },
    off: function off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(function (l) {
        return l !== listener;
      })) || []);
    }
  };
}
var FloatingNodeContext = /*#__PURE__*/React.createContext(null);
var FloatingTreeContext = /*#__PURE__*/React.createContext(null);

/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */
var useFloatingParentNodeId = function useFloatingParentNodeId() {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};

/**
 * Returns the nearest floating tree context, if available.
 */
var useFloatingTree = function useFloatingTree() {
  return React.useContext(FloatingTreeContext);
};

/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function useFloatingNodeId(customParentId) {
  var id = useId();
  var tree = useFloatingTree();
  var reactParentId = useFloatingParentNodeId();
  var parentId = customParentId || reactParentId;
  index(function () {
    var node = {
      id: id,
      parentId: parentId
    };
    tree == null || tree.addNode(node);
    return function () {
      tree == null || tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingNode(props) {
  var children = props.children,
    id = props.id;
  var parentId = useFloatingParentNodeId();
  return /*#__PURE__*/React.createElement(FloatingNodeContext.Provider, {
    value: React.useMemo(function () {
      return {
        id: id,
        parentId: parentId
      };
    }, [id, parentId])
  }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */
function FloatingTree(props) {
  var children = props.children;
  var nodesRef = React.useRef([]);
  var addNode = React.useCallback(function (node) {
    nodesRef.current = [].concat(_toConsumableArray(nodesRef.current), [node]);
  }, []);
  var removeNode = React.useCallback(function (node) {
    nodesRef.current = nodesRef.current.filter(function (n) {
      return n !== node;
    });
  }, []);
  var events = React.useState(function () {
    return createPubSub();
  })[0];
  return /*#__PURE__*/React.createElement(FloatingTreeContext.Provider, {
    value: React.useMemo(function () {
      return {
        nodesRef: nodesRef,
        addNode: addNode,
        removeNode: removeNode,
        events: events
      };
    }, [addNode, removeNode, events])
  }, children);
}
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function useLatestRef(value) {
  var ref = useRef(value);
  index(function () {
    ref.current = value;
  });
  return ref;
}
var safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    onOpenChange = context.onOpenChange,
    dataRef = context.dataRef,
    events = context.events,
    elements = context.elements;
  var _props2 = props,
    _props2$enabled = _props2.enabled,
    enabled = _props2$enabled === void 0 ? true : _props2$enabled,
    _props2$delay = _props2.delay,
    delay = _props2$delay === void 0 ? 0 : _props2$delay,
    _props2$handleClose = _props2.handleClose,
    handleClose = _props2$handleClose === void 0 ? null : _props2$handleClose,
    _props2$mouseOnly = _props2.mouseOnly,
    mouseOnly = _props2$mouseOnly === void 0 ? false : _props2$mouseOnly,
    _props2$restMs = _props2.restMs,
    restMs = _props2$restMs === void 0 ? 0 : _props2$restMs,
    _props2$move = _props2.move,
    move = _props2$move === void 0 ? true : _props2$move;
  var tree = useFloatingTree();
  var parentId = useFloatingParentNodeId();
  var handleCloseRef = useLatestRef(handleClose);
  var delayRef = useLatestRef(delay);
  var openRef = useLatestRef(open);
  var pointerTypeRef = React.useRef();
  var timeoutRef = React.useRef(-1);
  var handlerRef = React.useRef();
  var restTimeoutRef = React.useRef(-1);
  var blockMouseMoveRef = React.useRef(true);
  var performedPointerEventsMutationRef = React.useRef(false);
  var unbindMouseMoveRef = React.useRef(function () {});
  var isHoverOpen = React.useCallback(function () {
    var _dataRef$current$open;
    var type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When closing before opening, clear the delay timeouts to cancel it
  // from showing.
  React.useEffect(function () {
    if (!enabled) return;
    function onOpenChange(_ref) {
      var open = _ref.open;
      if (!open) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return function () {
      events.off('openchange', onOpenChange);
    };
  }, [enabled, events]);
  React.useEffect(function () {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, 'hover');
      }
    }
    var html = getDocument(elements.floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return function () {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  var closeWithDelay = React.useCallback(function (event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = 'hover';
    }
    var closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(function () {
        return onOpenChange(false, event, reason);
      }, closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  var cleanupMouseMoveHandler = useEffectEvent(function () {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  });
  var clearPointerEvents = useEffectEvent(function () {
    if (performedPointerEventsMutationRef.current) {
      var body = getDocument(elements.floating).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  React.useEffect(function () {
    if (!enabled) return;
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, 'open')) {
        return;
      }
      var openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(function () {
          if (!openRef.current) {
            onOpenChange(true, event, 'hover');
          }
        }, openDelay);
      } else {
        onOpenChange(true, event, 'hover');
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      unbindMouseMoveRef.current();
      var doc = getDocument(elements.floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current(_objectSpread(_objectSpread({}, dataRef.current.floatingContext), {}, {
          tree: tree,
          x: event.clientX,
          y: event.clientY,
          onClose: function onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            closeWithDelay(event, true, 'safe-polygon');
          }
        }));
        var handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = function () {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      var shouldClose = pointerTypeRef.current === 'touch' ? !contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current(_objectSpread(_objectSpread({}, dataRef.current.floatingContext), {}, {
        tree: tree,
        x: event.clientX,
        y: event.clientY,
        onClose: function onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      }))(event);
    }
    if (isElement(elements.domReference)) {
      var _elements$floating;
      var ref = elements.domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return function () {
        var _elements$floating2;
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [elements, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(function () {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      var body = getDocument(elements.floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      var floatingEl = elements.floating;
      if (isElement(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        var ref = elements.domReference;
        var parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(function (node) {
          return node.id === parentId;
        })) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floatingEl.style.pointerEvents = 'auto';
        return function () {
          ref.style.pointerEvents = '';
          floatingEl.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  index(function () {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  React.useEffect(function () {
    return function () {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  var reference = React.useMemo(function () {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove: function onMouseMove(event) {
        var nativeEvent = event.nativeEvent;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, 'hover');
          }
        }
        if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || restMs === 0) {
          return;
        }
        clearTimeout(restTimeoutRef.current);
        if (pointerTypeRef.current === 'touch') {
          handleMouseMove();
        } else {
          restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMs]);
  var floating = React.useMemo(function () {
    return {
      onMouseEnter: function onMouseEnter() {
        clearTimeout(timeoutRef.current);
      },
      onMouseLeave: function onMouseLeave(event) {
        closeWithDelay(event.nativeEvent, false);
      }
    };
  }, [closeWithDelay]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference,
      floating: floating
    } : {};
  }, [enabled, reference, floating]);
}
var NOOP = function NOOP() {};
var FloatingDelayGroupContext = /*#__PURE__*/React.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});

/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */
var useDelayGroupContext = function useDelayGroupContext() {
  return React.useContext(FloatingDelayGroupContext);
};
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function FloatingDelayGroup(props) {
  var children = props.children,
    delay = props.delay,
    _props$timeoutMs = props.timeoutMs,
    timeoutMs = _props$timeoutMs === void 0 ? 0 : _props$timeoutMs;
  var _React$useReducer = React.useReducer(function (prev, next) {
      return _objectSpread(_objectSpread({}, prev), next);
    }, {
      delay: delay,
      timeoutMs: timeoutMs,
      initialDelay: delay,
      currentId: null,
      isInstantPhase: false
    }),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    setState = _React$useReducer2[1];
  var initialCurrentIdRef = React.useRef(null);
  var setCurrentId = React.useCallback(function (currentId) {
    setState({
      currentId: currentId
    });
  }, []);
  index(function () {
    if (state.currentId) {
      if (initialCurrentIdRef.current === null) {
        initialCurrentIdRef.current = state.currentId;
      } else if (!state.isInstantPhase) {
        setState({
          isInstantPhase: true
        });
      }
    } else {
      if (state.isInstantPhase) {
        setState({
          isInstantPhase: false
        });
      }
      initialCurrentIdRef.current = null;
    }
  }, [state.currentId, state.isInstantPhase]);
  return /*#__PURE__*/React.createElement(FloatingDelayGroupContext.Provider, {
    value: React.useMemo(function () {
      return _objectSpread(_objectSpread({}, state), {}, {
        setState: setState,
        setCurrentId: setCurrentId
      });
    }, [state, setCurrentId])
  }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  var open = context.open,
    onOpenChange = context.onOpenChange,
    floatingId = context.floatingId;
  var _options2 = options,
    optionId = _options2.id;
  var id = optionId != null ? optionId : floatingId;
  var groupContext = useDelayGroupContext();
  var currentId = groupContext.currentId,
    setCurrentId = groupContext.setCurrentId,
    initialDelay = groupContext.initialDelay,
    setState = groupContext.setState,
    timeoutMs = groupContext.timeoutMs;
  index(function () {
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, 'close')
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [id, onOpenChange, setState, currentId, initialDelay]);
  index(function () {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        var timeout = window.setTimeout(unset, timeoutMs);
        return function () {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  index(function () {
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [open, setCurrentId, id]);
  return groupContext;
}
function getAncestors(nodes, id) {
  var _nodes$find;
  var allAncestors = [];
  var currentParentId = (_nodes$find = nodes.find(function (node) {
    return node.id === id;
  })) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    var currentNode = nodes.find(function (node) {
      return node.id === currentParentId;
    });
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}
function getChildren(nodes, id) {
  var allChildren = nodes.filter(function (node) {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  var currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(function (node) {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(function (n) {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  var deepestNodeId;
  var maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    var children = getChildren(nodes, nodeId);
    children.forEach(function (child) {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find(function (node) {
    return node.id === deepestNodeId;
  });
}

// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
var counterMap = /*#__PURE__*/new WeakMap();
var uncontrolledElementsSet = /*#__PURE__*/new WeakSet();
var markerMap = {};
var lockCount = 0;
var supportsInert = function supportsInert() {
  return typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
};
var unwrapHost = function unwrapHost(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctElements = function correctElements(parent, targets) {
  return targets.map(function (target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    return null;
  }).filter(function (x) {
    return x != null;
  });
};
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  var markerName = 'data-floating-ui-inert';
  var controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
  var avoidElements = correctElements(body, uncorrectedAvoidElements);
  var elementsToKeep = new Set();
  var elementsToStop = new Set(avoidElements);
  var hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, function (node) {
      if (getNodeName(node) === 'script') return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        var _attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
        var alreadyHidden = _attr !== null && _attr !== 'false';
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, '');
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  }
  lockCount++;
  return function () {
    hiddenElements.forEach(function (element) {
      var counterValue = (counterMap.get(element) || 0) - 1;
      var markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledElementsSet = new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  var body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
var getTabbableOptions = function getTabbableOptions() {
  return {
    getShadowRoot: true,
    displayCheck:
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
  };
};
function getTabbableIn(container, direction) {
  var allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  var activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  var nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  var containerElement = container || event.currentTarget;
  var relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  var tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(function (element) {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  var elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(function (element) {
    var tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

var HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
var timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
var FocusGuard = /*#__PURE__*/React.forwardRef(function FocusGuard(props, ref) {
  var _React$useState11 = React.useState(),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    role = _React$useState12[0],
    setRole = _React$useState12[1];
  index(function () {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return function () {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  var restProps = _defineProperty(_defineProperty({
    ref: ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: role,
    'aria-hidden': role ? undefined : true
  }, createAttribute('focus-guard'), ''), "style", HIDDEN_STYLES);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, restProps));
});
var PortalContext = /*#__PURE__*/React.createContext(null);
var attr = /*#__PURE__*/createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  var _props3 = props,
    id = _props3.id,
    root = _props3.root;
  var uniqueId = useId();
  var portalContext = usePortalContext();
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    portalNode = _React$useState14[0],
    setPortalNode = _React$useState14[1];
  var portalNodeRef = React.useRef(null);
  index(function () {
    return function () {
      portalNode == null || portalNode.remove();
      // Allow the subsequent layout effects to create a new node on updates.
      // The portal node will still be cleaned up on unmount.
      // https://github.com/floating-ui/floating-ui/issues/2454
      queueMicrotask(function () {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  index(function () {
    // Wait for the uniqueId to be generated before creating the portal node in
    // React <18 (using `useFloatingId` instead of the native `useId`).
    // https://github.com/floating-ui/floating-ui/issues/2778
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    var existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    var subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  index(function () {
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    var container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    var idWrapper = null;
    if (id) {
      idWrapper = document.createElement('div');
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    var subRoot = document.createElement('div');
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, '');
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(props) {
  var children = props.children,
    id = props.id,
    _props$root = props.root,
    root = _props$root === void 0 ? null : _props$root,
    _props$preserveTabOrd = props.preserveTabOrder,
    preserveTabOrder = _props$preserveTabOrd === void 0 ? true : _props$preserveTabOrd;
  var portalNode = useFloatingPortalNode({
    id: id,
    root: root
  });
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    focusManagerState = _React$useState16[0],
    setFocusManagerState = _React$useState16[1];
  var beforeOutsideRef = React.useRef(null);
  var afterOutsideRef = React.useRef(null);
  var beforeInsideRef = React.useRef(null);
  var afterInsideRef = React.useRef(null);
  var shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React.useEffect(function () {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        var focusing = event.type === 'focusin';
        var manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return function () {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/React.createElement(PortalContext.Provider, {
    value: React.useMemo(function () {
      return {
        preserveTabOrder: preserveTabOrder,
        beforeOutsideRef: beforeOutsideRef,
        afterOutsideRef: afterOutsideRef,
        beforeInsideRef: beforeInsideRef,
        afterInsideRef: afterInsideRef,
        portalNode: portalNode,
        setFocusManagerState: setFocusManagerState
      };
    }, [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: function onFocus(event) {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        var prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: function onFocus(event) {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        var nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
var usePortalContext = function usePortalContext() {
  return React.useContext(PortalContext);
};
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter(function (el) {
    return el.isConnected;
  });
  var tabbableEl = element;
  if (!tabbableEl || getNodeName(tabbableEl) === 'body') return;
  if (!isTabbable(tabbableEl, getTabbableOptions())) {
    var tabbableChild = tabbable(tabbableEl, getTabbableOptions())[0];
    if (tabbableChild) {
      tabbableEl = tabbableChild;
    }
  }
  previouslyFocusedElements.push(tabbableEl);
  if (previouslyFocusedElements.length > LIST_LIMIT) {
    previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find(function (el) {
    return el.isConnected;
  });
}
var VisuallyHiddenDismiss = /*#__PURE__*/React.forwardRef(function VisuallyHiddenDismiss(props, ref) {
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    type: "button",
    ref: ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */
function FloatingFocusManager(props) {
  var context = props.context,
    children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$order = props.order,
    order = _props$order === void 0 ? ['content'] : _props$order,
    _props$guards = props.guards,
    _guards = _props$guards === void 0 ? true : _props$guards,
    _props$initialFocus = props.initialFocus,
    initialFocus = _props$initialFocus === void 0 ? 0 : _props$initialFocus,
    _props$returnFocus = props.returnFocus,
    returnFocus = _props$returnFocus === void 0 ? true : _props$returnFocus,
    _props$restoreFocus = props.restoreFocus,
    restoreFocus = _props$restoreFocus === void 0 ? false : _props$restoreFocus,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? true : _props$modal,
    _props$visuallyHidden = props.visuallyHiddenDismiss,
    visuallyHiddenDismiss = _props$visuallyHidden === void 0 ? false : _props$visuallyHidden,
    _props$closeOnFocusOu = props.closeOnFocusOut,
    closeOnFocusOut = _props$closeOnFocusOu === void 0 ? true : _props$closeOnFocusOu;
  var open = context.open,
    refs = context.refs,
    nodeId = context.nodeId,
    onOpenChange = context.onOpenChange,
    events = context.events,
    dataRef = context.dataRef,
    floatingId = context.floatingId,
    _context$elements = context.elements,
    domReference = _context$elements.domReference,
    floating = _context$elements.floating;
  var ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
  // If the reference is a combobox and is typeable (e.g. input/textarea),
  // there are different focus semantics. The guards should not be rendered, but
  // aria-hidden should be applied to all nodes still. Further, the visually
  // hidden dismiss button should only appear at the end of the list, not the
  // start.
  var isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;

  // Force the guards to be rendered if the `inert` attribute is not supported.
  var guards = supportsInert() ? _guards : true;
  var orderRef = useLatestRef(order);
  var initialFocusRef = useLatestRef(initialFocus);
  var returnFocusRef = useLatestRef(returnFocus);
  var tree = useFloatingTree();
  var portalContext = usePortalContext();
  var startDismissButtonRef = React.useRef(null);
  var endDismissButtonRef = React.useRef(null);
  var preventReturnFocusRef = React.useRef(false);
  var isPointerDownRef = React.useRef(false);
  var tabbableIndexRef = React.useRef(-1);
  var isInsidePortal = portalContext != null;
  var firstElementChild = floating == null ? void 0 : floating.firstElementChild;
  // If the floating element is acting as a positioning wrapper rather than the
  // element that receives aria props, use it as the focus root instead.
  var floatingFocusNode = (firstElementChild == null ? void 0 : firstElementChild.id) === floatingId ? firstElementChild : floating;
  var getTabbableContent = useEffectEvent(function (container) {
    if (container === void 0) {
      container = floatingFocusNode;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  var getTabbableElements = useEffectEvent(function (container) {
    var content = getTabbableContent(container);
    return orderRef.current.map(function (type) {
      if (domReference && type === 'reference') {
        return domReference;
      }
      if (floatingFocusNode && type === 'floating') {
        return floatingFocusNode;
      }
      return content;
    }).filter(Boolean).flat();
  });
  React.useEffect(function () {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === 'Tab') {
        // The focus guards have nothing to focus, so we need to stop the event.
        if (contains(floatingFocusNode, activeElement(getDocument(floatingFocusNode))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        var els = getTabbableElements();
        var target = getTarget(event);
        if (orderRef.current[0] === 'reference' && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === 'floating' && target === floatingFocusNode && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    var doc = getDocument(floatingFocusNode);
    doc.addEventListener('keydown', onKeyDown);
    return function () {
      doc.removeEventListener('keydown', onKeyDown);
    };
  }, [disabled, domReference, floatingFocusNode, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(function () {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      var target = getTarget(event);
      var tabbableContent = getTabbableContent();
      var tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener('focusin', handleFocusIn);
    return function () {
      floating.removeEventListener('focusin', handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  React.useEffect(function () {
    if (disabled) return;
    if (!closeOnFocusOut) return;

    // In Safari, buttons lose focus when pressing them.
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(function () {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      var relatedTarget = event.relatedTarget;
      queueMicrotask(function () {
        var movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && (getChildren(tree.nodesRef.current, nodeId).find(function (node) {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find(function (node) {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));

        // Restore focus to the previous tabbable element index to prevent
        // focus from being lost outside the floating tree.
        if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusNode)) === getDocument(floatingFocusNode).body) {
          // Let `FloatingPortal` effect knows that focus is still inside the
          // floating tree.
          if (isHTMLElement(floatingFocusNode)) {
            floatingFocusNode == null || floatingFocusNode.focus();
          }
          var prevTabbableIndex = tabbableIndexRef.current;
          var tabbableContent = getTabbableContent();
          var nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusNode;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }

        // Focus did not move inside the floating tree, and there are no tabbable
        // portal guards to handle closing.
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current &&
        // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event);
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener('focusout', handleFocusOutside);
      domReference.addEventListener('pointerdown', handlePointerDown);
      floating.addEventListener('focusout', handleFocusOutside);
      return function () {
        domReference.removeEventListener('focusout', handleFocusOutside);
        domReference.removeEventListener('pointerdown', handlePointerDown);
        floating.removeEventListener('focusout', handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, floatingFocusNode, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox]);
  React.useEffect(function () {
    var _portalContext$portal;
    if (disabled) return;

    // Don't hide portals nested within the parent portal.
    var portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
    if (floating) {
      var insideElements = [floating].concat(portalNodes, [startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null]).filter(function (x) {
        return x != null;
      });
      var cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return function () {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  index(function () {
    if (disabled || !isHTMLElement(floatingFocusNode)) return;
    var doc = getDocument(floatingFocusNode);
    var previouslyFocusedElement = activeElement(doc);

    // Wait for any layout effect state setters to execute to set `tabIndex`.
    queueMicrotask(function () {
      var focusableElements = getTabbableElements(floatingFocusNode);
      var initialFocusValue = initialFocusRef.current;
      var elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusNode;
      var focusAlreadyInsideFloatingEl = contains(floatingFocusNode, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusNode
        });
      }
    });
  }, [disabled, open, floatingFocusNode, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index(function () {
    if (disabled || !floatingFocusNode) return;
    var preventReturnFocusScroll = false;
    var doc = getDocument(floatingFocusNode);
    var previouslyFocusedElement = activeElement(doc);
    var contextData = dataRef.current;
    var openEvent = contextData.openEvent;
    addPreviouslyFocusedElement(previouslyFocusedElement);

    // Dismissing via outside press should always ignore `returnFocus` to
    // prevent unwanted scrolling.
    function onOpenChange(_ref) {
      var open = _ref.open,
        reason = _ref.reason,
        event = _ref.event,
        nested = _ref.nested;
      if (open) {
        openEvent = event;
      }
      if (reason === 'escape-key' && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === 'hover' && event.type === 'mouseleave') {
        preventReturnFocusRef.current = true;
      }
      if (reason !== 'outside-press') return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on('openchange', onOpenChange);
    return function () {
      events.off('openchange', onOpenChange);
      var activeEl = activeElement(doc);
      var isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(function (node) {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      var shouldFocusReference = isFocusInsideFloatingTree || openEvent && ['click', 'mousedown'].includes(openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      var returnElement = getPreviouslyFocusedElement();
      if (
      // eslint-disable-next-line react-hooks/exhaustive-deps
      returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && (
      // If the focus moved somewhere else after mount, avoid returning focus
      // since it likely entered a different element which should be
      // respected: https://github.com/floating-ui/floating-ui/issues/2607
      returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
        enqueueFocus(returnElement, {
          // When dismissing nested floating elements, by the time the rAF has
          // executed, the menus will all have been unmounted. When they try
          // to get focused, the calls get ignored — leaving the root
          // reference focused as desired.
          cancelPrevious: false,
          preventScroll: preventReturnFocusScroll
        });
      }
    };
  }, [disabled, floating, floatingFocusNode, returnFocusRef, dataRef, refs, events, tree, nodeId]);

  // Synchronize the `context` & `modal` value to the FloatingPortal context.
  // It will decide whether or not it needs to render its own guards.
  index(function () {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal: modal,
      closeOnFocusOut: closeOnFocusOut,
      open: open,
      onOpenChange: onOpenChange,
      refs: refs
    });
    return function () {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  index(function () {
    if (disabled) return;
    if (!floatingFocusNode) return;
    if (typeof MutationObserver !== 'function') return;
    if (ignoreInitialFocus) return;
    var handleMutation = function handleMutation() {
      var tabIndex = floatingFocusNode.getAttribute('tabindex');
      var tabbableContent = getTabbableContent();
      var activeEl = activeElement(getDocument(floating));
      var tabbableIndex = tabbableContent.indexOf(activeEl);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
      if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
        if (tabIndex !== '0') {
          floatingFocusNode.setAttribute('tabindex', '0');
        }
      } else if (tabIndex !== '-1') {
        floatingFocusNode.setAttribute('tabindex', '-1');
      }
    };
    handleMutation();
    var observer = new MutationObserver(handleMutation);
    observer.observe(floatingFocusNode, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return function () {
      observer.disconnect();
    };
  }, [disabled, floating, floatingFocusNode, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /*#__PURE__*/React.createElement(VisuallyHiddenDismiss, {
      ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
      onClick: function onClick(event) {
        return onOpenChange(false, event.nativeEvent);
      }
    }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
  }
  var shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: function onFocus(event) {
      if (modal) {
        var els = getTabbableElements();
        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          var nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/React.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: function onFocus(event) {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          var prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}
var activeLocks = /*#__PURE__*/new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */
var FloatingOverlay = /*#__PURE__*/React.forwardRef(function FloatingOverlay(props, ref) {
  var _props$lockScroll = props.lockScroll,
    lockScroll = _props$lockScroll === void 0 ? false : _props$lockScroll,
    rest = _objectWithoutProperties(props, _excluded5);
  var lockId = useId();
  index(function () {
    if (!lockScroll) return;
    activeLocks.add(lockId);
    var isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
    var bodyStyle = document.body.style;
    // RTL <body> scrollbar
    var scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    var paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    var scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    var scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) {
      bodyStyle[paddingProp] = scrollbarWidth + "px";
    }

    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
      var _window$visualViewpor, _window$visualViewpor2;
      // iOS 12 does not support `visualViewport`.
      var offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
      var offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
      Object.assign(bodyStyle, {
        position: 'fixed',
        top: -(scrollY - Math.floor(offsetTop)) + "px",
        left: -(scrollX - Math.floor(offsetLeft)) + "px",
        right: '0'
      });
    }
    return function () {
      activeLocks.delete(lockId);
      if (activeLocks.size === 0) {
        Object.assign(bodyStyle, _defineProperty({
          overflow: ''
        }, paddingProp, ''));
        if (isIOS) {
          Object.assign(bodyStyle, {
            position: '',
            top: '',
            left: '',
            right: ''
          });
          window.scrollTo(scrollX, scrollY);
        }
      }
    };
  }, [lockId, lockScroll]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, rest, {
    style: _objectSpread({
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, rest.style)
  }));
});
function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    onOpenChange = context.onOpenChange,
    dataRef = context.dataRef,
    domReference = context.elements.domReference;
  var _props4 = props,
    _props4$enabled = _props4.enabled,
    enabled = _props4$enabled === void 0 ? true : _props4$enabled,
    _props4$event = _props4.event,
    eventOption = _props4$event === void 0 ? 'click' : _props4$event,
    _props4$toggle = _props4.toggle,
    toggle = _props4$toggle === void 0 ? true : _props4$toggle,
    _props4$ignoreMouse = _props4.ignoreMouse,
    ignoreMouse = _props4$ignoreMouse === void 0 ? false : _props4$ignoreMouse,
    _props4$keyboardHandl = _props4.keyboardHandlers,
    keyboardHandlers = _props4$keyboardHandl === void 0 ? true : _props4$keyboardHandl;
  var pointerTypeRef = React.useRef();
  var didKeyDownRef = React.useRef(false);
  var reference = React.useMemo(function () {
    return {
      onPointerDown: function onPointerDown(event) {
        pointerTypeRef.current = event.pointerType;
      },
      onMouseDown: function onMouseDown(event) {
        var pointerType = pointerTypeRef.current;

        // Ignore all buttons except for the "main" button.
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (event.button !== 0) return;
        if (eventOption === 'click') return;
        if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
        if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          // Prevent stealing focus from the floating element
          event.preventDefault();
          onOpenChange(true, event.nativeEvent, 'click');
        }
      },
      onClick: function onClick(event) {
        var pointerType = pointerTypeRef.current;
        if (eventOption === 'mousedown' && pointerTypeRef.current) {
          pointerTypeRef.current = undefined;
          return;
        }
        if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
        if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
          onOpenChange(false, event.nativeEvent, 'click');
        } else {
          onOpenChange(true, event.nativeEvent, 'click');
        }
      },
      onKeyDown: function onKeyDown(event) {
        pointerTypeRef.current = undefined;
        if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
          return;
        }
        if (event.key === ' ' && !isSpaceIgnored(domReference)) {
          // Prevent scrolling
          event.preventDefault();
          didKeyDownRef.current = true;
        }
        if (event.key === 'Enter') {
          if (open && toggle) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            onOpenChange(true, event.nativeEvent, 'click');
          }
        }
      },
      onKeyUp: function onKeyUp(event) {
        if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
          return;
        }
        if (event.key === ' ' && didKeyDownRef.current) {
          didKeyDownRef.current = false;
          if (open && toggle) {
            onOpenChange(false, event.nativeEvent, 'click');
          } else {
            onOpenChange(true, event.nativeEvent, 'click');
          }
        }
      }
    };
  }, [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, toggle]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference
    } : {};
  }, [enabled, reference]);
}
function createVirtualElement(domElement, data) {
  var offsetX = null;
  var offsetY = null;
  var isAutoUpdateEvent = false;
  return {
    contextElement: domElement || undefined,
    getBoundingClientRect: function getBoundingClientRect() {
      var _data$dataRef$current;
      var domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      var isXAxis = data.axis === 'x' || data.axis === 'both';
      var isYAxis = data.axis === 'y' || data.axis === 'both';
      var canTrackCursorOnAutoUpdate = ['mouseenter', 'mousemove'].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
      var width = domRect.width;
      var height = domRect.height;
      var x = domRect.x;
      var y = domRect.y;
      if (offsetX == null && data.x && isXAxis) {
        offsetX = domRect.x - data.x;
      }
      if (offsetY == null && data.y && isYAxis) {
        offsetY = domRect.y - data.y;
      }
      x -= offsetX || 0;
      y -= offsetY || 0;
      width = 0;
      height = 0;
      if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
        width = data.axis === 'y' ? domRect.width : 0;
        height = data.axis === 'x' ? domRect.height : 0;
        x = isXAxis && data.x != null ? data.x : x;
        y = isYAxis && data.y != null ? data.y : y;
      } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
        height = data.axis === 'x' ? domRect.height : height;
        width = data.axis === 'y' ? domRect.width : width;
      }
      isAutoUpdateEvent = true;
      return {
        width: width,
        height: height,
        x: x,
        y: y,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x
      };
    }
  };
}
function isMouseBasedEvent(event) {
  return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */
function useClientPoint(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    dataRef = context.dataRef,
    _context$elements2 = context.elements,
    floating = _context$elements2.floating,
    domReference = _context$elements2.domReference,
    refs = context.refs;
  var _props5 = props,
    _props5$enabled = _props5.enabled,
    enabled = _props5$enabled === void 0 ? true : _props5$enabled,
    _props5$axis = _props5.axis,
    axis = _props5$axis === void 0 ? 'both' : _props5$axis,
    _props5$x = _props5.x,
    x = _props5$x === void 0 ? null : _props5$x,
    _props5$y = _props5.y,
    y = _props5$y === void 0 ? null : _props5$y;
  var initialRef = React.useRef(false);
  var cleanupListenerRef = React.useRef(null);
  var _React$useState17 = React.useState(),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    pointerType = _React$useState18[0],
    setPointerType = _React$useState18[1];
  var _React$useState19 = React.useState([]),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    reactive = _React$useState20[0],
    setReactive = _React$useState20[1];
  var setReference = useEffectEvent(function (x, y) {
    if (initialRef.current) return;

    // Prevent setting if the open event was not a mouse-like one
    // (e.g. focus to open, then hover over the reference element).
    // Only apply if the event exists.
    if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) {
      return;
    }
    refs.setPositionReference(createVirtualElement(domReference, {
      x: x,
      y: y,
      axis: axis,
      dataRef: dataRef,
      pointerType: pointerType
    }));
  });
  var handleReferenceEnterOrMove = useEffectEvent(function (event) {
    if (x != null || y != null) return;
    if (!open) {
      setReference(event.clientX, event.clientY);
    } else if (!cleanupListenerRef.current) {
      // If there's no cleanup, there's no listener, but we want to ensure
      // we add the listener if the cursor landed on the floating element and
      // then back on the reference (i.e. it's interactive).
      setReactive([]);
    }
  });

  // If the pointer is a mouse-like pointer, we want to continue following the
  // mouse even if the floating element is transitioning out. On touch
  // devices, this is undesirable because the floating element will move to
  // the dismissal touch point.
  var openCheck = isMouseLikePointerType(pointerType) ? floating : open;
  var addListener = React.useCallback(function () {
    // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
    if (!openCheck || !enabled || x != null || y != null) return;
    var win = getWindow(floating);
    function handleMouseMove(event) {
      var target = getTarget(event);
      if (!contains(floating, target)) {
        setReference(event.clientX, event.clientY);
      } else {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      }
    }
    if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
      win.addEventListener('mousemove', handleMouseMove);
      var cleanup = function cleanup() {
        win.removeEventListener('mousemove', handleMouseMove);
        cleanupListenerRef.current = null;
      };
      cleanupListenerRef.current = cleanup;
      return cleanup;
    }
    refs.setPositionReference(domReference);
  }, [openCheck, enabled, x, y, floating, dataRef, refs, domReference, setReference]);
  React.useEffect(function () {
    return addListener();
  }, [addListener, reactive]);
  React.useEffect(function () {
    if (enabled && !floating) {
      initialRef.current = false;
    }
  }, [enabled, floating]);
  React.useEffect(function () {
    if (!enabled && open) {
      initialRef.current = true;
    }
  }, [enabled, open]);
  index(function () {
    if (enabled && (x != null || y != null)) {
      initialRef.current = false;
      setReference(x, y);
    }
  }, [enabled, x, y, setReference]);
  var reference = React.useMemo(function () {
    function setPointerTypeRef(_ref) {
      var pointerType = _ref.pointerType;
      setPointerType(pointerType);
    }
    return {
      onPointerDown: setPointerTypeRef,
      onPointerEnter: setPointerTypeRef,
      onMouseMove: handleReferenceEnterOrMove,
      onMouseEnter: handleReferenceEnterOrMove
    };
  }, [handleReferenceEnterOrMove]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference
    } : {};
  }, [enabled, reference]);
}
var bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
var captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
var normalizeProp = function normalizeProp(normalizable) {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    onOpenChange = context.onOpenChange,
    elements = context.elements,
    dataRef = context.dataRef;
  var _props6 = props,
    _props6$enabled = _props6.enabled,
    enabled = _props6$enabled === void 0 ? true : _props6$enabled,
    _props6$escapeKey = _props6.escapeKey,
    escapeKey = _props6$escapeKey === void 0 ? true : _props6$escapeKey,
    _props6$outsidePress = _props6.outsidePress,
    unstable_outsidePress = _props6$outsidePress === void 0 ? true : _props6$outsidePress,
    _props6$outsidePressE = _props6.outsidePressEvent,
    outsidePressEvent = _props6$outsidePressE === void 0 ? 'pointerdown' : _props6$outsidePressE,
    _props6$referencePres = _props6.referencePress,
    referencePress = _props6$referencePres === void 0 ? false : _props6$referencePres,
    _props6$referencePres2 = _props6.referencePressEvent,
    referencePressEvent = _props6$referencePres2 === void 0 ? 'pointerdown' : _props6$referencePres2,
    _props6$ancestorScrol = _props6.ancestorScroll,
    ancestorScroll = _props6$ancestorScrol === void 0 ? false : _props6$ancestorScrol,
    bubbles = _props6.bubbles,
    capture = _props6.capture;
  var tree = useFloatingTree();
  var outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : function () {
    return false;
  });
  var outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  var insideReactTreeRef = React.useRef(false);
  var endedOrStartedInsideRef = React.useRef(false);
  var _normalizeProp = normalizeProp(bubbles),
    escapeKeyBubbles = _normalizeProp.escapeKey,
    outsidePressBubbles = _normalizeProp.outsidePress;
  var _normalizeProp2 = normalizeProp(capture),
    escapeKeyCapture = _normalizeProp2.escapeKey,
    outsidePressCapture = _normalizeProp2.outsidePress;
  var closeOnEscapeKeyDown = useEffectEvent(function (event) {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    var nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        var shouldDismiss = true;
        children.forEach(function (child) {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, 'escape-key');
  });
  var closeOnEscapeKeyDownCapture = useEffectEvent(function (event) {
    var _getTarget2;
    var callback = function callback() {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener('keydown', callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener('keydown', callback);
  });
  var closeOnPressOutside = useEffectEvent(function (event) {
    var _dataRef$current$floa2;
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;

    // When click outside is lazy (`click` event), handle dragging.
    // Don't close if:
    // - The click started inside the floating element.
    // - The click ended inside the floating element.
    var endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === 'click' && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    var target = getTarget(event);
    var inertSelector = "[" + createAttribute('inert') + "]";
    var markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    var targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      var nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }

    // Check if the click occurred on a third-party element injected after the
    // floating element rendered.
    if (markers.length && isElement(target) && !isRootElement(target) &&
    // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) &&
    // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every(function (marker) {
      return !contains(targetRootAncestor, marker);
    })) {
      return;
    }

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      var canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      var canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      var xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        var isRTL = getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    var nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    var targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(function (node) {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      var shouldDismiss = true;
      children.forEach(function (child) {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, 'outside-press');
  });
  var closeOnPressOutsideCapture = useEffectEvent(function (event) {
    var _getTarget4;
    var callback = function callback() {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  React.useEffect(function () {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event, 'ancestor-scroll');
    }
    var doc = getDocument(elements.floating);
    escapeKey && doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    var ancestors = [];
    if (ancestorScroll) {
      if (isElement(elements.domReference)) {
        ancestors = getOverflowAncestors(elements.domReference);
      }
      if (isElement(elements.floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.floating));
      }
      if (!isElement(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(function (ancestor) {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(function (ancestor) {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return function () {
      escapeKey && doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach(function (ancestor) {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  React.useEffect(function () {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  var reference = React.useMemo(function () {
    return _defineProperty({
      onKeyDown: closeOnEscapeKeyDown
    }, bubbleHandlerKeys[referencePressEvent], function (event) {
      if (referencePress) {
        onOpenChange(false, event.nativeEvent, 'reference-press');
      }
    });
  }, [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  var floating = React.useMemo(function () {
    return _defineProperty({
      onKeyDown: closeOnEscapeKeyDown,
      onMouseDown: function onMouseDown() {
        endedOrStartedInsideRef.current = true;
      },
      onMouseUp: function onMouseUp() {
        endedOrStartedInsideRef.current = true;
      }
    }, captureHandlerKeys[outsidePressEvent], function () {
      insideReactTreeRef.current = true;
    });
  }, [closeOnEscapeKeyDown, outsidePressEvent]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference,
      floating: floating
    } : {};
  }, [enabled, reference, floating]);
}
function useFloatingRootContext(options) {
  var _options$open = options.open,
    open = _options$open === void 0 ? false : _options$open,
    onOpenChangeProp = options.onOpenChange,
    elementsProp = options.elements;
  var floatingId = useId();
  var dataRef = React.useRef({});
  var _React$useState21 = React.useState(function () {
      return createPubSub();
    }),
    _React$useState22 = _slicedToArray(_React$useState21, 1),
    events = _React$useState22[0];
  var nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    var optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error('Cannot pass a virtual element to the `elements.reference` option,', 'as it must be a real DOM element. Use `refs.setPositionReference()`', 'instead.');
    }
  }
  var _React$useState23 = React.useState(elementsProp.reference),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    positionReference = _React$useState24[0],
    setPositionReference = _React$useState24[1];
  var onOpenChange = useEffectEvent(function (open, event, reason) {
    dataRef.current.openEvent = open ? event : undefined;
    events.emit('openchange', {
      open: open,
      event: event,
      reason: reason,
      nested: nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
  });
  var refs = React.useMemo(function () {
    return {
      setPositionReference: setPositionReference
    };
  }, []);
  var elements = React.useMemo(function () {
    return {
      reference: positionReference || elementsProp.reference || null,
      floating: elementsProp.floating || null,
      domReference: elementsProp.reference
    };
  }, [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(function () {
    return {
      dataRef: dataRef,
      open: open,
      onOpenChange: onOpenChange,
      elements: elements,
      events: events,
      floatingId: floatingId,
      refs: refs
    };
  }, [open, onOpenChange, elements, events, floatingId, refs]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  var _options3 = options,
    nodeId = _options3.nodeId;
  var internalRootContext = useFloatingRootContext(_objectSpread(_objectSpread({}, options), {}, {
    elements: _objectSpread({
      reference: null,
      floating: null
    }, options.elements)
  }));
  var rootContext = options.rootContext || internalRootContext;
  var computedElements = rootContext.elements;
  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    _domReference = _React$useState26[0],
    setDomReference = _React$useState26[1];
  var _React$useState27 = React.useState(null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    positionReference = _React$useState28[0],
    _setPositionReference = _React$useState28[1];
  var optionDomReference = computedElements == null ? void 0 : computedElements.reference;
  var domReference = optionDomReference || _domReference;
  var domReferenceRef = React.useRef(null);
  var tree = useFloatingTree();
  index(function () {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  var position = useFloating$1(_objectSpread(_objectSpread({}, options), {}, {
    elements: _objectSpread(_objectSpread({}, computedElements), positionReference && {
      reference: positionReference
    })
  }));
  var setPositionReference = React.useCallback(function (node) {
    var computedPositionReference = isElement(node) ? {
      getBoundingClientRect: function getBoundingClientRect() {
        return node.getBoundingClientRect();
      },
      contextElement: node
    } : node;
    // Store the positionReference in state if the DOM reference is specified externally via the
    // `elements.reference` option. This ensures that it won't be overridden on future renders.
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  var setReference = React.useCallback(function (node) {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  var refs = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, position.refs), {}, {
      setReference: setReference,
      setPositionReference: setPositionReference,
      domReference: domReferenceRef
    });
  }, [position.refs, setReference, setPositionReference]);
  var elements = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, position.elements), {}, {
      domReference: domReference
    });
  }, [position.elements, domReference]);
  var context = React.useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, position), rootContext), {}, {
      refs: refs,
      elements: elements,
      nodeId: nodeId
    });
  }, [position, refs, elements, nodeId, rootContext]);
  index(function () {
    rootContext.dataRef.current.floatingContext = context;
    var node = tree == null ? void 0 : tree.nodesRef.current.find(function (node) {
      return node.id === nodeId;
    });
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(function () {
    return _objectSpread(_objectSpread({}, position), {}, {
      context: context,
      refs: refs,
      elements: elements
    });
  }, [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    onOpenChange = context.onOpenChange,
    events = context.events,
    dataRef = context.dataRef,
    elements = context.elements;
  var _props7 = props,
    _props7$enabled = _props7.enabled,
    enabled = _props7$enabled === void 0 ? true : _props7$enabled,
    _props7$visibleOnly = _props7.visibleOnly,
    visibleOnly = _props7$visibleOnly === void 0 ? true : _props7$visibleOnly;
  var blockFocusRef = React.useRef(false);
  var timeoutRef = React.useRef();
  var keyboardModalityRef = React.useRef(true);
  React.useEffect(function () {
    if (!enabled) return;
    var win = getWindow(elements.domReference);

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener('blur', onBlur);
    win.addEventListener('keydown', onKeyDown, true);
    return function () {
      win.removeEventListener('blur', onBlur);
      win.removeEventListener('keydown', onKeyDown, true);
    };
  }, [elements.domReference, open, enabled]);
  React.useEffect(function () {
    if (!enabled) return;
    function onOpenChange(_ref) {
      var reason = _ref.reason;
      if (reason === 'reference-press' || reason === 'escape-key') {
        blockFocusRef.current = true;
      }
    }
    events.on('openchange', onOpenChange);
    return function () {
      events.off('openchange', onOpenChange);
    };
  }, [events, enabled]);
  React.useEffect(function () {
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  var reference = React.useMemo(function () {
    return {
      onPointerDown: function onPointerDown(event) {
        if (isVirtualPointerEvent(event.nativeEvent)) return;
        keyboardModalityRef.current = false;
      },
      onMouseLeave: function onMouseLeave() {
        blockFocusRef.current = false;
      },
      onFocus: function onFocus(event) {
        if (blockFocusRef.current) return;
        var target = getTarget(event.nativeEvent);
        if (visibleOnly && isElement(target)) {
          try {
            // Mac Safari unreliably matches `:focus-visible` on the reference
            // if focus was outside the page initially - use the fallback
            // instead.
            if (isSafari() && isMac()) throw Error();
            if (!target.matches(':focus-visible')) return;
          } catch (e) {
            // Old browsers will throw an error when using `:focus-visible`.
            if (!keyboardModalityRef.current && !isTypeableElement(target)) {
              return;
            }
          }
        }
        onOpenChange(true, event.nativeEvent, 'focus');
      },
      onBlur: function onBlur(event) {
        blockFocusRef.current = false;
        var relatedTarget = event.relatedTarget;
        var nativeEvent = event.nativeEvent;

        // Hit the non-modal focus management portal guard. Focus will be
        // moved into the floating element immediately after.
        var movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

        // Wait for the window blur listener to fire.
        timeoutRef.current = window.setTimeout(function () {
          var _dataRef$current$floa;
          var activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);

          // Focus left the page, keep it open.
          if (!relatedTarget && activeEl === elements.domReference) return;

          // When focusing the reference element (e.g. regular click), then
          // clicking into the floating element, prevent it from hiding.
          // Note: it must be focusable, e.g. `tabindex="-1"`.
          // We can not rely on relatedTarget to point to the correct element
          // as it will only point to the shadow host of the newly focused element
          // and not the element that actually has received focus if it is located
          // inside a shadow root.
          if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
            return;
          }
          onOpenChange(false, nativeEvent, 'focus');
        });
      }
    };
  }, [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference
    } : {};
  }, [enabled, reference]);
}
var ACTIVE_KEY = 'active';
var SELECTED_KEY = 'selected';
function mergeProps(userProps, propsList, elementKey) {
  var map = new Map();
  var isItem = elementKey === 'item';
  var domUserProps = userProps;
  if (isItem && userProps) {
    var _ = userProps[ACTIVE_KEY],
      __ = userProps[SELECTED_KEY],
      validProps = _objectWithoutProperties(userProps, [ACTIVE_KEY, SELECTED_KEY].map(_toPropertyKey));
    domUserProps = validProps;
  }
  return _objectSpread(_objectSpread(_objectSpread({}, elementKey === 'floating' && {
    tabIndex: -1
  }), domUserProps), propsList.map(function (value) {
    var propsOrGetProps = value ? value[elementKey] : null;
    if (typeof propsOrGetProps === 'function') {
      return userProps ? propsOrGetProps(userProps) : null;
    }
    return propsOrGetProps;
  }).concat(userProps).reduce(function (acc, props) {
    if (!props) {
      return acc;
    }
    Object.entries(props).forEach(function (_ref) {
      var _ref8 = _slicedToArray(_ref, 2),
        key = _ref8[0],
        value = _ref8[1];
      if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
        return;
      }
      if (key.indexOf('on') === 0) {
        if (!map.has(key)) {
          map.set(key, []);
        }
        if (typeof value === 'function') {
          var _map$get;
          (_map$get = map.get(key)) == null || _map$get.push(value);
          acc[key] = function () {
            var _map$get2;
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(function (fn) {
              return fn.apply(void 0, args);
            }).find(function (val) {
              return val !== undefined;
            });
          };
        }
      } else {
        acc[key] = value;
      }
    });
    return acc;
  }, {}));
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  var referenceDeps = propsList.map(function (key) {
    return key == null ? void 0 : key.reference;
  });
  var floatingDeps = propsList.map(function (key) {
    return key == null ? void 0 : key.floating;
  });
  var itemDeps = propsList.map(function (key) {
    return key == null ? void 0 : key.item;
  });
  var getReferenceProps = React.useCallback(function (userProps) {
    return mergeProps(userProps, propsList, 'reference');
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  referenceDeps);
  var getFloatingProps = React.useCallback(function (userProps) {
    return mergeProps(userProps, propsList, 'floating');
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  floatingDeps);
  var getItemProps = React.useCallback(function (userProps) {
    return mergeProps(userProps, propsList, 'item');
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  itemDeps);
  return React.useMemo(function () {
    return {
      getReferenceProps: getReferenceProps,
      getFloatingProps: getFloatingProps,
      getItemProps: getItemProps
    };
  }, [getReferenceProps, getFloatingProps, getItemProps]);
}
var isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case 'vertical':
      return vertical;
    case 'horizontal':
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  var vertical = key === ARROW_UP || key === ARROW_DOWN;
  var horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  var vertical = key === ARROW_DOWN;
  var horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  var vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  var horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  var vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  var horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */
function useListNavigation(context, props) {
  var open = context.open,
    onOpenChange = context.onOpenChange,
    elements = context.elements;
  var listRef = props.listRef,
    activeIndex = props.activeIndex,
    _props$onNavigate = props.onNavigate,
    unstable_onNavigate = _props$onNavigate === void 0 ? function () {} : _props$onNavigate,
    _props$enabled = props.enabled,
    enabled = _props$enabled === void 0 ? true : _props$enabled,
    _props$selectedIndex = props.selectedIndex,
    selectedIndex = _props$selectedIndex === void 0 ? null : _props$selectedIndex,
    _props$allowEscape = props.allowEscape,
    allowEscape = _props$allowEscape === void 0 ? false : _props$allowEscape,
    _props$loop2 = props.loop,
    loop = _props$loop2 === void 0 ? false : _props$loop2,
    _props$nested = props.nested,
    nested = _props$nested === void 0 ? false : _props$nested,
    _props$rtl = props.rtl,
    rtl = _props$rtl === void 0 ? false : _props$rtl,
    _props$virtual = props.virtual,
    virtual = _props$virtual === void 0 ? false : _props$virtual,
    _props$focusItemOnOpe = props.focusItemOnOpen,
    focusItemOnOpen = _props$focusItemOnOpe === void 0 ? 'auto' : _props$focusItemOnOpe,
    _props$focusItemOnHov = props.focusItemOnHover,
    focusItemOnHover = _props$focusItemOnHov === void 0 ? true : _props$focusItemOnHov,
    _props$openOnArrowKey = props.openOnArrowKeyDown,
    openOnArrowKeyDown = _props$openOnArrowKey === void 0 ? true : _props$openOnArrowKey,
    _props$disabledIndice = props.disabledIndices,
    disabledIndices = _props$disabledIndice === void 0 ? undefined : _props$disabledIndice,
    _props$orientation2 = props.orientation,
    orientation = _props$orientation2 === void 0 ? 'vertical' : _props$orientation2,
    _props$cols2 = props.cols,
    cols = _props$cols2 === void 0 ? 1 : _props$cols2,
    _props$scrollItemInto = props.scrollItemIntoView,
    scrollItemIntoView = _props$scrollItemInto === void 0 ? true : _props$scrollItemInto,
    virtualItemRef = props.virtualItemRef,
    itemSizes = props.itemSizes,
    _props$dense2 = props.dense,
    dense = _props$dense2 === void 0 ? false : _props$dense2;
  if (process.env.NODE_ENV !== "production") {
    if (allowEscape) {
      if (!loop) {
        warn('`useListNavigation` looping must be enabled to allow escaping.');
      }
      if (!virtual) {
        warn('`useListNavigation` must be virtual to allow escaping.');
      }
    }
    if (orientation === 'vertical' && cols > 1) {
      warn('In grid list navigation mode (`cols` > 1), the `orientation` should', 'be either "horizontal" or "both".');
    }
  }
  var parentId = useFloatingParentNodeId();
  var tree = useFloatingTree();
  var onNavigate = useEffectEvent(unstable_onNavigate);
  var focusItemOnOpenRef = React.useRef(focusItemOnOpen);
  var indexRef = React.useRef(selectedIndex != null ? selectedIndex : -1);
  var keyRef = React.useRef(null);
  var isPointerModalityRef = React.useRef(true);
  var previousOnNavigateRef = React.useRef(onNavigate);
  var previousMountedRef = React.useRef(!!elements.floating);
  var forceSyncFocus = React.useRef(false);
  var forceScrollIntoViewRef = React.useRef(false);
  var disabledIndicesRef = useLatestRef(disabledIndices);
  var latestOpenRef = useLatestRef(open);
  var scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
  var floatingRef = useLatestRef(elements.floating);
  var selectedIndexRef = useLatestRef(selectedIndex);
  var _React$useState29 = React.useState(),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    activeId = _React$useState30[0],
    setActiveId = _React$useState30[1];
  var _React$useState31 = React.useState(),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    virtualId = _React$useState32[0],
    setVirtualId = _React$useState32[1];
  var focusItem = useEffectEvent(function (listRef, indexRef, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    function runFocus(item) {
      if (virtual) {
        setActiveId(item.id);
        tree == null || tree.events.emit('virtualfocus', item);
        if (virtualItemRef) {
          virtualItemRef.current = item;
        }
      } else {
        enqueueFocus(item, {
          preventScroll: true,
          // Mac Safari does not move the virtual cursor unless the focus call
          // is sync. However, for the very first focus call, we need to wait
          // for the position to be ready in order to prevent unwanted
          // scrolling. This means the virtual cursor will not move to the first
          // item when first opening the floating element, but will on
          // subsequent calls. `preventScroll` is supported in modern Safari,
          // so we can use that instead.
          // iOS Safari must be async or the first item will not be focused.
          sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
        });
      }
    }
    var initialItem = listRef.current[indexRef.current];
    if (initialItem) {
      runFocus(initialItem);
    }
    requestAnimationFrame(function () {
      var waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      var scrollIntoViewOptions = scrollItemIntoViewRef.current;
      var shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
        // by all browsers.
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
          block: 'nearest',
          inline: 'nearest'
        } : scrollIntoViewOptions);
      }
    });
  });
  index(function () {
    document.createElement('div').focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);

  // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
  // element. Also, reset `activeIndex` upon closing the floating element.
  index(function () {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        // Regardless of the pointer modality, we want to ensure the selected
        // item comes into view when the floating element is opened.
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      // Since the user can specify `onNavigate` conditionally
      // (onNavigate: open ? setActiveIndex : setSelectedIndex),
      // we store and call the previous function.
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);

  // Sync `activeIndex` to be the focused item while the floating element is
  // open.
  index(function () {
    if (!enabled) return;
    if (open && elements.floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndexRef.current != null) {
          return;
        }

        // Reset while the floating element was open (e.g. the list changed).
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }

        // Initial sync.
        if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          var runs = 0;
          var waitForListPopulated = function waitForListPopulated() {
            if (listRef.current[0] == null) {
              // Avoid letting the browser paint if possible on the first try,
              // otherwise use rAF. Don't try more than twice, since something
              // is wrong otherwise.
              if (runs < 2) {
                var scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);

  // Ensure the parent floating element has focus when a nested child closes
  // to allow arrow key navigation to work after the pointer leaves the child.
  index(function () {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    var nodes = tree.nodesRef.current;
    var parent = (_nodes$find = nodes.find(function (node) {
      return node.id === parentId;
    })) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    var activeEl = activeElement(getDocument(elements.floating));
    var treeContainsActiveEl = nodes.some(function (node) {
      return node.context && contains(node.context.elements.floating, activeEl);
    });
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  index(function () {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item) {
      setVirtualId(item.id);
      if (virtualItemRef) {
        virtualItemRef.current = item;
      }
    }
    tree.events.on('virtualfocus', handleVirtualFocus);
    return function () {
      tree.events.off('virtualfocus', handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  index(function () {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!elements.floating;
  });
  index(function () {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  var hasActiveIndex = activeIndex != null;
  var item = React.useMemo(function () {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      var index = listRef.current.indexOf(currentTarget);
      if (index !== -1) {
        onNavigate(index);
      }
    }
    var props = _objectSpread({
      onFocus: function onFocus(_ref) {
        var currentTarget = _ref.currentTarget;
        syncCurrentTarget(currentTarget);
      },
      onClick: function onClick(_ref2) {
        var currentTarget = _ref2.currentTarget;
        return currentTarget.focus({
          preventScroll: true
        });
      }
    }, focusItemOnHover && {
      onMouseMove: function onMouseMove(_ref3) {
        var currentTarget = _ref3.currentTarget;
        syncCurrentTarget(currentTarget);
      },
      onPointerLeave: function onPointerLeave(_ref4) {
        var pointerType = _ref4.pointerType;
        if (!isPointerModalityRef.current || pointerType === 'touch') {
          return;
        }
        indexRef.current = -1;
        focusItem(listRef, indexRef);
        onNavigate(null);
        if (!virtual) {
          enqueueFocus(floatingRef.current, {
            preventScroll: true
          });
        }
      }
    });
    return props;
  }, [open, floatingRef, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  var commonOnKeyDown = useEffectEvent(function (event) {
    isPointerModalityRef.current = false;
    forceSyncFocus.current = true;

    // If the floating element is animating out, ignore navigation. Otherwise,
    // the `activeIndex` gets set to 0 despite not being open so the next time
    // the user ArrowDowns, the first item won't be focused.
    if (!latestOpenRef.current && event.currentTarget === floatingRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
      stopEvent(event);
      onOpenChange(false, event.nativeEvent, 'list-navigation');
      if (isHTMLElement(elements.domReference) && !virtual) {
        elements.domReference.focus();
      }
      return;
    }
    var currentIndex = indexRef.current;
    var minIndex = getMinIndex(listRef, disabledIndices);
    var maxIndex = getMaxIndex(listRef, disabledIndices);
    if (event.key === 'Home') {
      stopEvent(event);
      indexRef.current = minIndex;
      onNavigate(indexRef.current);
    }
    if (event.key === 'End') {
      stopEvent(event);
      indexRef.current = maxIndex;
      onNavigate(indexRef.current);
    }

    // Grid navigation.
    if (cols > 1) {
      var sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, function () {
        return {
          width: 1,
          height: 1
        };
      });
      // To calculate movements on the grid, we use hypothetical cell indices
      // as if every item was 1x1, then convert back to real indices.
      var cellMap = buildCellMap(sizes, cols, dense);
      var minGridIndex = cellMap.findIndex(function (index) {
        return index != null && !isDisabled(listRef.current, index, disabledIndices);
      });
      // last enabled index
      var maxGridIndex = cellMap.reduce(function (foundIndex, index, cellIndex) {
        return index != null && !isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex;
      }, -1);
      indexRef.current = cellMap[getGridNavigatedIndex({
        current: cellMap.map(function (itemIndex) {
          return itemIndex != null ? listRef.current[itemIndex] : null;
        })
      }, {
        event: event,
        orientation: orientation,
        loop: loop,
        cols: cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([].concat(_toConsumableArray(disabledIndices || listRef.current.map(function (_, index) {
          return isDisabled(listRef.current, index) ? index : undefined;
        })), [undefined]), cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols,
        // use a corner matching the edge closest to the direction
        // we're moving in so we don't end up in the same item. Prefer
        // top/left over bottom/right.
        event.key === ARROW_DOWN ? 'bl' : event.key === ARROW_RIGHT ? 'tr' : 'tl'),
        stopEvent: true
      })]; // navigated cell will never be nullish

      onNavigate(indexRef.current);
      if (orientation === 'both') {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);

      // Reset the index if no item is focused.
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate(indexRef.current);
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices: disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices: disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices: disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices: disabledIndices
          }));
        }
      }
      if (isIndexOutOfBounds(listRef, indexRef.current)) {
        onNavigate(null);
      } else {
        onNavigate(indexRef.current);
      }
    }
  });
  var ariaActiveDescendantProp = React.useMemo(function () {
    return virtual && open && hasActiveIndex && {
      'aria-activedescendant': virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  var floating = React.useMemo(function () {
    return _objectSpread(_objectSpread({
      'aria-orientation': orientation === 'both' ? undefined : orientation
    }, !isTypeableCombobox(elements.domReference) && ariaActiveDescendantProp), {}, {
      onKeyDown: commonOnKeyDown,
      onPointerMove: function onPointerMove() {
        isPointerModalityRef.current = true;
      }
    });
  }, [ariaActiveDescendantProp, commonOnKeyDown, elements.domReference, orientation]);
  var reference = React.useMemo(function () {
    var disabledIndices = disabledIndicesRef.current;
    var activeItem = listRef.current.find(function (item) {
      return (item == null ? void 0 : item.id) === activeId;
    });
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === 'auto' && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      // `pointerdown` fires first, reset the state then perform the checks.
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === 'auto' && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return _objectSpread(_objectSpread({}, ariaActiveDescendantProp), {}, {
      onKeyDown: function onKeyDown(event) {
        isPointerModalityRef.current = false;
        var isArrowKey = event.key.indexOf('Arrow') === 0;
        var isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        var isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
        var isMainKey = isMainOrientationKey(event.key, orientation);
        var isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
        if (virtual && open) {
          var rootNode = tree == null ? void 0 : tree.nodesRef.current.find(function (node) {
            return node.parentId == null;
          });
          var deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isArrowKey && deepestNode && virtualItemRef) {
            var eventObject = new KeyboardEvent('keydown', {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              var isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              var dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(undefined);
              }
            }
            if (isMainKey && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }

        // If a floating element should not open on arrow key down, avoid
        // setting `activeIndex` while it's closed.
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          keyRef.current = nested && isMainKey ? null : event.key;
        }
        if (nested) {
          if (isCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinIndex(listRef, disabledIndices);
              onNavigate(indexRef.current);
            } else {
              onOpenChange(true, event.nativeEvent, 'list-navigation');
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, 'list-navigation');
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate(indexRef.current);
          }
        }
      },
      onFocus: function onFocus() {
        if (open && !virtual) {
          onNavigate(null);
        }
      },
      onPointerDown: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    });
  }, [activeId, ariaActiveDescendantProp, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference,
      floating: floating,
      item: item
    } : {};
  }, [enabled, reference, floating, item]);
}
var componentRoleToAriaRoleMap = /*#__PURE__*/new Map([['select', 'listbox'], ['combobox', 'listbox'], ['label', false]]);

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    floatingId = context.floatingId;
  var _props8 = props,
    _props8$enabled = _props8.enabled,
    enabled = _props8$enabled === void 0 ? true : _props8$enabled,
    _props8$role = _props8.role,
    role = _props8$role === void 0 ? 'dialog' : _props8$role;
  var ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  var referenceId = useId();
  var parentId = useFloatingParentNodeId();
  var isNested = parentId != null;
  var reference = React.useMemo(function () {
    if (ariaRole === 'tooltip' || role === 'label') {
      return _defineProperty({}, "aria-" + (role === 'label' ? 'labelledby' : 'describedby'), open ? floatingId : undefined);
    }
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      'aria-expanded': open ? 'true' : 'false',
      'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
      'aria-controls': open ? floatingId : undefined
    }, ariaRole === 'listbox' && {
      role: 'combobox'
    }), ariaRole === 'menu' && {
      id: referenceId
    }), ariaRole === 'menu' && isNested && {
      role: 'menuitem'
    }), role === 'select' && {
      'aria-autocomplete': 'none'
    }), role === 'combobox' && {
      'aria-autocomplete': 'list'
    });
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  var floating = React.useMemo(function () {
    var floatingProps = _objectSpread({
      id: floatingId
    }, ariaRole && {
      role: ariaRole
    });
    if (ariaRole === 'tooltip' || role === 'label') {
      return floatingProps;
    }
    return _objectSpread(_objectSpread({}, floatingProps), ariaRole === 'menu' && {
      'aria-labelledby': referenceId
    });
  }, [ariaRole, floatingId, referenceId, role]);
  var item = React.useCallback(function (_ref) {
    var active = _ref.active,
      selected = _ref.selected;
    var commonProps = _objectSpread({
      role: 'option'
    }, active && {
      id: floatingId + "-option"
    });

    // For `menu`, we are unable to tell if the item is a `menuitemradio`
    // or `menuitemcheckbox`. For backwards-compatibility reasons, also
    // avoid defaulting to `menuitem` as it may overwrite custom role props.
    switch (role) {
      case 'select':
        return _objectSpread(_objectSpread({}, commonProps), {}, {
          'aria-selected': active && selected
        });
      case 'combobox':
        {
          return _objectSpread(_objectSpread({}, commonProps), active && {
            'aria-selected': true
          });
        }
    }
    return {};
  }, [floatingId, role]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference,
      floating: floating,
      item: item
    } : {};
  }, [enabled, reference, floating, item]);
}

// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
var camelCaseToKebabCase = function camelCaseToKebabCase(str) {
  return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function ($, ofs) {
    return (ofs ? '-' : '') + $.toLowerCase();
  });
};
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  var _React$useState33 = React.useState(open),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    isMounted = _React$useState34[0],
    setIsMounted = _React$useState34[1];
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(function () {
    if (!open && isMounted) {
      var timeout = setTimeout(function () {
        return setIsMounted(false);
      }, durationMs);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  var open = context.open,
    floating = context.elements.floating;
  var _props9 = props,
    _props9$duration = _props9.duration,
    duration = _props9$duration === void 0 ? 250 : _props9$duration;
  var isNumberDuration = typeof duration === 'number';
  var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  var _React$useState35 = React.useState('unmounted'),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    status = _React$useState36[0],
    setStatus = _React$useState36[1];
  var isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === 'close') {
    setStatus('unmounted');
  }
  index(function () {
    if (!floating) return;
    if (open) {
      setStatus('initial');
      var frame = requestAnimationFrame(function () {
        setStatus('open');
      });
      return function () {
        cancelAnimationFrame(frame);
      };
    }
    setStatus('close');
  }, [open, floating]);
  return {
    isMounted: isMounted,
    status: status
  };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  var _props10 = props,
    _props10$initial = _props10.initial,
    unstable_initial = _props10$initial === void 0 ? {
      opacity: 0
    } : _props10$initial,
    unstable_open = _props10.open,
    unstable_close = _props10.close,
    unstable_common = _props10.common,
    _props10$duration = _props10.duration,
    duration = _props10$duration === void 0 ? 250 : _props10$duration;
  var placement = context.placement;
  var side = placement.split('-')[0];
  var fnArgs = React.useMemo(function () {
    return {
      side: side,
      placement: placement
    };
  }, [side, placement]);
  var isNumberDuration = typeof duration === 'number';
  var openDuration = (isNumberDuration ? duration : duration.open) || 0;
  var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  var _React$useState37 = React.useState(function () {
      return _objectSpread(_objectSpread({}, execWithArgsOrReturn(unstable_common, fnArgs)), execWithArgsOrReturn(unstable_initial, fnArgs));
    }),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    styles = _React$useState38[0],
    setStyles = _React$useState38[1];
  var _useTransitionStatus = useTransitionStatus(context, {
      duration: duration
    }),
    isMounted = _useTransitionStatus.isMounted,
    status = _useTransitionStatus.status;
  var initialRef = useLatestRef(unstable_initial);
  var openRef = useLatestRef(unstable_open);
  var closeRef = useLatestRef(unstable_close);
  var commonRef = useLatestRef(unstable_common);
  index(function () {
    var initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    var closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    var commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    var openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce(function (acc, key) {
      acc[key] = '';
      return acc;
    }, {});
    if (status === 'initial') {
      setStyles(function (styles) {
        return _objectSpread(_objectSpread({
          transitionProperty: styles.transitionProperty
        }, commonStyles), initialStyles);
      });
    }
    if (status === 'open') {
      setStyles(_objectSpread(_objectSpread({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
        transitionDuration: openDuration + "ms"
      }, commonStyles), openStyles));
    }
    if (status === 'close') {
      var _styles = closeStyles || initialStyles;
      setStyles(_objectSpread(_objectSpread({
        transitionProperty: Object.keys(_styles).map(camelCaseToKebabCase).join(','),
        transitionDuration: closeDuration + "ms"
      }, commonStyles), _styles));
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted: isMounted,
    styles: styles
  };
}

/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */
function useTypeahead(context, props) {
  var _ref;
  var open = context.open,
    dataRef = context.dataRef;
  var listRef = props.listRef,
    activeIndex = props.activeIndex,
    unstable_onMatch = props.onMatch,
    unstable_onTypingChange = props.onTypingChange,
    _props$enabled2 = props.enabled,
    enabled = _props$enabled2 === void 0 ? true : _props$enabled2,
    _props$findMatch = props.findMatch,
    findMatch = _props$findMatch === void 0 ? null : _props$findMatch,
    _props$resetMs = props.resetMs,
    resetMs = _props$resetMs === void 0 ? 750 : _props$resetMs,
    _props$ignoreKeys = props.ignoreKeys,
    ignoreKeys = _props$ignoreKeys === void 0 ? [] : _props$ignoreKeys,
    _props$selectedIndex2 = props.selectedIndex,
    selectedIndex = _props$selectedIndex2 === void 0 ? null : _props$selectedIndex2;
  var timeoutIdRef = React.useRef();
  var stringRef = React.useRef('');
  var prevIndexRef = React.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
  var matchIndexRef = React.useRef(null);
  var onMatch = useEffectEvent(unstable_onMatch);
  var onTypingChange = useEffectEvent(unstable_onTypingChange);
  var findMatchRef = useLatestRef(findMatch);
  var ignoreKeysRef = useLatestRef(ignoreKeys);
  index(function () {
    if (open) {
      clearTimeout(timeoutIdRef.current);
      matchIndexRef.current = null;
      stringRef.current = '';
    }
  }, [open]);
  index(function () {
    // Sync arrow key navigation but not typeahead navigation.
    if (open && stringRef.current === '') {
      var _ref2;
      prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
    }
  }, [open, selectedIndex, activeIndex]);
  var setTypingChange = useEffectEvent(function (value) {
    if (value) {
      if (!dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    } else {
      if (dataRef.current.typing) {
        dataRef.current.typing = value;
        onTypingChange(value);
      }
    }
  });
  var onKeyDown = useEffectEvent(function (event) {
    function getMatchingIndex(list, orderedList, string) {
      var str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(function (text) {
        return (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0;
      });
      return str ? list.indexOf(str) : -1;
    }
    var listContent = listRef.current;
    if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
      if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) {
        setTypingChange(false);
      } else if (event.key === ' ') {
        stopEvent(event);
      }
    }
    if (listContent == null || ignoreKeysRef.current.includes(event.key) ||
    // Character key.
    event.key.length !== 1 ||
    // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open && event.key !== ' ') {
      stopEvent(event);
      setTypingChange(true);
    }

    // Bail out if the list contains a word like "llama" or "aaron". TODO:
    // allow it in this case, too.
    var allowRapidSuccessionOfFirstLetter = listContent.every(function (text) {
      var _text$, _text$2;
      return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
    });

    // Allows the user to cycle through items that start with the same letter
    // in rapid succession.
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(function () {
      stringRef.current = '';
      prevIndexRef.current = matchIndexRef.current;
      setTypingChange(false);
    }, resetMs);
    var prevIndex = prevIndexRef.current;
    var index = getMatchingIndex(listContent, [].concat(_toConsumableArray(listContent.slice((prevIndex || 0) + 1)), _toConsumableArray(listContent.slice(0, (prevIndex || 0) + 1))), stringRef.current);
    if (index !== -1) {
      onMatch(index);
      matchIndexRef.current = index;
    } else if (event.key !== ' ') {
      stringRef.current = '';
      setTypingChange(false);
    }
  });
  var reference = React.useMemo(function () {
    return {
      onKeyDown: onKeyDown
    };
  }, [onKeyDown]);
  var floating = React.useMemo(function () {
    return {
      onKeyDown: onKeyDown,
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          setTypingChange(false);
        }
      }
    };
  }, [onKeyDown, setTypingChange]);
  return React.useMemo(function () {
    return enabled ? {
      reference: reference,
      floating: floating
    } : {};
  }, [enabled, reference, floating]);
}
function getArgsWithCustomFloatingHeight(state, height) {
  return _objectSpread(_objectSpread({}, state), {}, {
    rects: _objectSpread(_objectSpread({}, state.rects), {}, {
      floating: _objectSpread(_objectSpread({}, state.rects.floating), {}, {
        height: height
      })
    })
  });
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */
var inner = function inner(props) {
  return {
    name: 'inner',
    options: props,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _evaluate, listRef, overflowRef, onFallbackChange, _evaluate$offset, innerOffset, _evaluate$index, index, _evaluate$minItemsVis, minItemsVisible, _evaluate$referenceOv, referenceOverflowThreshold, scrollRef, detectOverflowOptions, rects, floating, item, nextArgs, el, overflow, refOverflow, diffY, nextY, maxHeight;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _evaluate = evaluate(props, state), listRef = _evaluate.listRef, overflowRef = _evaluate.overflowRef, onFallbackChange = _evaluate.onFallbackChange, _evaluate$offset = _evaluate.offset, innerOffset = _evaluate$offset === void 0 ? 0 : _evaluate$offset, _evaluate$index = _evaluate.index, index = _evaluate$index === void 0 ? 0 : _evaluate$index, _evaluate$minItemsVis = _evaluate.minItemsVisible, minItemsVisible = _evaluate$minItemsVis === void 0 ? 4 : _evaluate$minItemsVis, _evaluate$referenceOv = _evaluate.referenceOverflowThreshold, referenceOverflowThreshold = _evaluate$referenceOv === void 0 ? 0 : _evaluate$referenceOv, scrollRef = _evaluate.scrollRef, detectOverflowOptions = _objectWithoutProperties(_evaluate, _excluded6);
              rects = state.rects, floating = state.elements.floating;
              item = listRef.current[index];
              if (process.env.NODE_ENV !== "production") {
                if (!state.placement.startsWith('bottom')) {
                  warn('`placement` side must be "bottom" when using the `inner`', 'middleware.');
                }
              }
              if (item) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {});
            case 6:
              _context.t0 = _objectSpread;
              _context.t1 = _objectSpread({}, state);
              _context.next = 10;
              return offset(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state);
            case 10:
              _context.t2 = _context.sent;
              nextArgs = (0, _context.t0)(_context.t1, _context.t2);
              el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
              _context.next = 15;
              return detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            case 15:
              overflow = _context.sent;
              _context.next = 18;
              return detectOverflow(nextArgs, _objectSpread(_objectSpread({}, detectOverflowOptions), {}, {
                elementContext: 'reference'
              }));
            case 18:
              refOverflow = _context.sent;
              diffY = Math.max(0, overflow.top);
              nextY = nextArgs.y + diffY;
              maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
              el.style.maxHeight = maxHeight + "px";
              el.scrollTop = diffY;

              // There is not enough space, fallback to standard anchored positioning
              if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) {
                  ReactDOM.flushSync(function () {
                    return onFallbackChange(true);
                  });
                } else {
                  ReactDOM.flushSync(function () {
                    return onFallbackChange(false);
                  });
                }
              }
              if (!overflowRef) {
                _context.next = 29;
                break;
              }
              _context.next = 28;
              return detectOverflow(getArgsWithCustomFloatingHeight(_objectSpread(_objectSpread({}, nextArgs), {}, {
                y: nextY
              }), el.offsetHeight), detectOverflowOptions);
            case 28:
              overflowRef.current = _context.sent;
            case 29:
              return _context.abrupt("return", {
                y: nextY
              });
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  };
};
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */
function useInnerOffset(context, props) {
  var open = context.open,
    elements = context.elements;
  var _props$enabled3 = props.enabled,
    enabled = _props$enabled3 === void 0 ? true : _props$enabled3,
    overflowRef = props.overflowRef,
    scrollRef = props.scrollRef,
    unstable_onChange = props.onChange;
  var onChange = useEffectEvent(unstable_onChange);
  var controlledScrollingRef = React.useRef(false);
  var prevScrollTopRef = React.useRef(null);
  var initialOverflowRef = React.useRef(null);
  React.useEffect(function () {
    if (!enabled) return;
    function onWheel(e) {
      if (e.ctrlKey || !el || overflowRef.current == null) {
        return;
      }
      var dY = e.deltaY;
      var isAtTop = overflowRef.current.top >= -0.5;
      var isAtBottom = overflowRef.current.bottom >= -0.5;
      var remainingScroll = el.scrollHeight - el.clientHeight;
      var sign = dY < 0 ? -1 : 1;
      var method = dY < 0 ? 'max' : 'min';
      if (el.scrollHeight <= el.clientHeight) {
        return;
      }
      if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
        e.preventDefault();
        ReactDOM.flushSync(function () {
          onChange(function (d) {
            return d + Math[method](dY, remainingScroll * sign);
          });
        });
      } else if (/firefox/i.test(getUserAgent())) {
        // Needed to propagate scrolling during momentum scrolling phase once
        // it gets limited by the boundary. UX improvement, not critical.
        el.scrollTop += dY;
      }
    }
    var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
    if (open && el) {
      el.addEventListener('wheel', onWheel);

      // Wait for the position to be ready.
      requestAnimationFrame(function () {
        prevScrollTopRef.current = el.scrollTop;
        if (overflowRef.current != null) {
          initialOverflowRef.current = _objectSpread({}, overflowRef.current);
        }
      });
      return function () {
        prevScrollTopRef.current = null;
        initialOverflowRef.current = null;
        el.removeEventListener('wheel', onWheel);
      };
    }
  }, [enabled, open, elements.floating, overflowRef, scrollRef, onChange]);
  var floating = React.useMemo(function () {
    return {
      onKeyDown: function onKeyDown() {
        controlledScrollingRef.current = true;
      },
      onWheel: function onWheel() {
        controlledScrollingRef.current = false;
      },
      onPointerMove: function onPointerMove() {
        controlledScrollingRef.current = false;
      },
      onScroll: function onScroll() {
        var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (!overflowRef.current || !el || !controlledScrollingRef.current) {
          return;
        }
        if (prevScrollTopRef.current !== null) {
          var scrollDiff = el.scrollTop - prevScrollTopRef.current;
          if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) {
            ReactDOM.flushSync(function () {
              return onChange(function (d) {
                return d + scrollDiff;
              });
            });
          }
        }

        // [Firefox] Wait for the height change to have been applied.
        requestAnimationFrame(function () {
          prevScrollTopRef.current = el.scrollTop;
        });
      }
    };
  }, [elements.floating, onChange, overflowRef, scrollRef]);
  return React.useMemo(function () {
    return enabled ? {
      floating: floating
    } : {};
  }, [enabled, floating]);
}
function isPointInPolygon(point, polygon) {
  var _point = _slicedToArray(point, 2),
    x = _point[0],
    y = _point[1];
  var isInside = false;
  var length = polygon.length;
  for (var i = 0, j = length - 1; i < length; j = i++) {
    var _ref10 = polygon[i] || [0, 0],
      _ref11 = _slicedToArray(_ref10, 2),
      xi = _ref11[0],
      yi = _ref11[1];
    var _ref12 = polygon[j] || [0, 0],
      _ref13 = _slicedToArray(_ref12, 2),
      xj = _ref13[0],
      yj = _ref13[1];
    var intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  var _options4 = options,
    _options4$buffer = _options4.buffer,
    buffer = _options4$buffer === void 0 ? 0.5 : _options4$buffer,
    _options4$blockPointe = _options4.blockPointerEvents,
    blockPointerEvents = _options4$blockPointe === void 0 ? false : _options4$blockPointe,
    _options4$requireInte = _options4.requireIntent,
    requireIntent = _options4$requireInte === void 0 ? true : _options4$requireInte;
  var timeoutId;
  var hasLanded = false;
  var lastX = null;
  var lastY = null;
  var lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    var currentTime = performance.now();
    var elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    var deltaX = x - lastX;
    var deltaY = y - lastY;
    var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    var speed = distance / elapsedTime; // px / ms

    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  var fn = function fn(_ref) {
    var x = _ref.x,
      y = _ref.y,
      placement = _ref.placement,
      elements = _ref.elements,
      onClose = _ref.onClose,
      nodeId = _ref.nodeId,
      tree = _ref.tree;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId);
        onClose();
      }
      clearTimeout(timeoutId);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      var clientX = event.clientX,
        clientY = event.clientY;
      var clientPoint = [clientX, clientY];
      var target = getTarget(event);
      var isLeave = event.type === 'mouseleave';
      var isOverFloatingEl = contains(elements.floating, target);
      var isOverReferenceEl = contains(elements.domReference, target);
      var refRect = elements.domReference.getBoundingClientRect();
      var rect = elements.floating.getBoundingClientRect();
      var side = placement.split('-')[0];
      var cursorLeaveFromRight = x > rect.right - rect.width / 2;
      var cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      var isOverReferenceRect = isInside(clientPoint, refRect);
      var isFloatingWider = rect.width > refRect.width;
      var isFloatingTaller = rect.height > refRect.height;
      var left = (isFloatingWider ? refRect : rect).left;
      var right = (isFloatingWider ? refRect : rect).right;
      var top = (isFloatingTaller ? refRect : rect).top;
      var bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }

      // Prevent overlapping floating element from being stuck in an open-close
      // loop: https://github.com/floating-ui/floating-ui/issues/1910
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }

      // If any nested child is open, abort.
      if (tree && getChildren(tree.nodesRef.current, nodeId).some(function (_ref2) {
        var context = _ref2.context;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }

      // If the pointer is leaving from the opposite side, the "buffer" logic
      // creates a point where the floating element remains open, but should be
      // ignored.
      // A constant of 1 handles floating point rounding errors.
      if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) {
        return close();
      }

      // Ignore when the cursor is within the rectangular trough between the
      // two elements. Since the triangle is created from the cursor point,
      // which can start beyond the ref element's edge, traversing back and
      // forth from the ref to the floating element can cause it to close. This
      // ensures it always remains open in that case.
      var rectPoly = [];
      switch (side) {
        case 'top':
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case 'bottom':
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case 'left':
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case 'right':
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        var _ref14 = _slicedToArray(_ref3, 2),
          x = _ref14[0],
          y = _ref14[1];
        switch (side) {
          case 'top':
            {
              var cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              var cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y + buffer + 1];
              var commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
              return [cursorPointOne, cursorPointTwo].concat(commonPoints);
            }
          case 'bottom':
            {
              var _cursorPointOne = [isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              var _cursorPointTwo = [isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4, y - buffer];
              var _commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
              return [_cursorPointOne, _cursorPointTwo].concat(_commonPoints);
            }
          case 'left':
            {
              var _cursorPointOne2 = [x + buffer + 1, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              var _cursorPointTwo2 = [x + buffer + 1, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              var _commonPoints2 = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
              return [].concat(_commonPoints2, [_cursorPointOne2, _cursorPointTwo2]);
            }
          case 'right':
            {
              var _cursorPointOne3 = [x - buffer, isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              var _cursorPointTwo3 = [x - buffer, isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4];
              var _commonPoints3 = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
              return [_cursorPointOne3, _cursorPointTwo3].concat(_commonPoints3);
            }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        var cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        var cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents: blockPointerEvents
  };
  return fn;
}
export { Composite, CompositeItem, FloatingArrow, FloatingDelayGroup, FloatingFocusManager, FloatingList, FloatingNode, FloatingOverlay, FloatingPortal, FloatingTree, inner, safePolygon, useClick, useClientPoint, useDelayGroup, useDelayGroupContext, useDismiss, useFloating, useFloatingNodeId, useFloatingParentNodeId, useFloatingPortalNode, useFloatingRootContext, useFloatingTree, useFocus, useHover, useId, useInnerOffset, useInteractions, useListItem, useListNavigation, useMergeRefs, useRole, useTransitionStatus, useTransitionStyles, useTypeahead };